import { render, staticRenderFns } from "./AddStudentPayment.vue?vue&type=template&id=cea1a198&scoped=true"
import script from "./AddStudentPayment.vue?vue&type=script&lang=js"
export * from "./AddStudentPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea1a198",
  null
  
)

export default component.exports